<template>
    <div class="page">
        <div class="container-div">
            <ion-grid>
                <ion-row class="search-view">
                    <ion-col>
                        <ion-row align-items-stretch>
                            <ion-col size="12" size-md="3">
                                <ion-label>Select Dashboard</ion-label>
                                <div class="border-line-34 margin-top-10">
                                    <ion-select
                                        class="form-select select-mobile"
                                        v-model="chartName"
                                        @ionChange="selectDashboardChart($event)"
                                        placeholder="Select Dashboard"
                                        interface="action-sheet"
                                    >
                                        <ion-select-option
                                        v-for="(chart, index) in chartTypes"
                                        :key="index"
                                        :value="chart.dashboardCode"
                                        >{{chart.dashboardName}}</ion-select-option>
                                    </ion-select>

                                    <select
                                        @change="selectDashboardChart($event)"
                                        class="input-select select-web"
                                        v-model="chartName"
                                        placeholder="Select Status"
                                    >
                                        <option
                                        v-for="(chart, index) in chartTypes"
                                        :key="index"
                                        :value="chart.dashboardCode"
                                        >{{ chart.dashboardName }}</option>
                                    </select>
                                </div>
                            </ion-col>

                            <!-- Code commented for new changes based on TO DO- 93 -->

                            <!-- <ion-col size="12" size-md="2">
                                <ion-label>Branch ID</ion-label>
                                <div class="border-line-34 margin-top-10">
                                    <ion-input
                                    class="form-input"
                                    type="text"
                                    id="branchId"
                                    @input="branchId = $event.target.value"
                                    maxlength="50"
                                    placeholder="Branch ID"
                                    :value = branchId
                                    ></ion-input>
                                </div>
                            </ion-col> -->
                            <ion-col size="12" size-md="3">
                                <ion-label>Select Branch</ion-label>
                                <div class="border-line-34 margin-top-10">
                                    <ion-select
                                        class="form-select select-mobile"
                                        v-model="selectedBranchId"
                                        placeholder="Select Dashboard"
                                        @ionChange="changeBranch($event)"
                                        interface="action-sheet"
                                    >
                                        <ion-select-option
                                        v-for="(branchInfo, index) in this.branchList"
                                        :key="index"
                                        :value="branchInfo.branchId"
                                        >{{ branchInfo.branchName }}</ion-select-option>
                                    </ion-select>

                                    <select
                                        class="input-select select-web"
                                        v-model="selectedBranchId"
                                        @change="changeBranch($event)"
                                        placeholder="Select Status"
                                    >
                                        <option
                                        v-for="(branchInfo, index) in this.branchList"
                                        :key="index"
                                        :value="branchInfo.branchId"
                                        >{{ branchInfo.branchName }}</option>
                                    </select>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="3" >
                                <ion-label>Select Station</ion-label>
                                <div class="border-line-34 margin-top-10">
                                    <ion-select
                                        class="form-select select-mobile"
                                        v-model="selectedStationId"
                                        @ionChange="changeStation($event)"
                                        placeholder=""
                                        interface="action-sheet"
                                    >
                                    <ion-select-option
                                        v-for="(station, index) in stationList" 
                                        :key="index" 
                                        :value="station.stationId"
                                    >{{ station.stationName }}</ion-select-option>
                                    </ion-select>

                                    <select
                                        v-model="selectedStationId"
                                        @change="changeStation($event)"
                                        class="input-select select-web"
                                        placeholder=""
                                    >
                                    <option
                                        v-for="(station, index) in stationList" 
                                        :key="index" 
                                        :value="station.stationId"
                                    >{{ station.stationName }}</option>
                                    </select>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="3" >
                                <ion-label>Select Output</ion-label>
                                <div class="border-line-34 margin-top-10">
                                    <ion-select
                                        class="form-select select-mobile"
                                        v-model="selectedOutputId"
                                        @ionChange="changeOutput($event)"
                                        placeholder=""
                                        interface="action-sheet"
                                    >
                                    <ion-select-option
                                        v-for="(output, index) in outputList" 
                                        :key="index" 
                                        :value="output.outputId"
                                    >{{ output.outputName }}</ion-select-option>
                                    </ion-select>

                                    <select
                                        v-model="selectedOutputId"
                                        class="input-select select-web"
                                        placeholder=""
                                        @change="changeOutput($event)"
                                    >
                                    <option
                                        v-for="(output, index) in outputList" 
                                        :key="index" 
                                        :value="output.outputId"
                                    >{{ output.outputName }}</option>
                                    </select>
                                </div>
                            </ion-col>
                            <ion-col v-if="this.chartName == 'CU' || this.chartName == 'CAD'">
                                <ion-row>
                                    <ion-col size="12" size-md="4">
                                        <ion-label>Filter</ion-label>
                                        <div class="border-line-34 margin-top-10">
                                            <ion-select
                                                class="form-select select-mobile"
                                                v-model="selectedFilter"
                                                @ionChange="changeFilter($event)"
                                                placeholder=""
                                                interface="action-sheet"
                                            >
                                            <ion-select-option
                                                v-for="(report, index) in reportFilter" 
                                                :key="index" 
                                                :value="report.code"
                                            >{{ report.description }}</ion-select-option>
                                            </ion-select>

                                            <select
                                                v-model="selectedFilter"
                                                class="input-select select-web"
                                                placeholder=""
                                                @change="changeFilter($event)"
                                            >
                                            <option
                                                v-for="(report, index) in reportFilter" 
                                                :key="index" 
                                                :value="report.code"
                                            >{{ report.description }}</option>
                                            </select>
                                        </div>
                                    </ion-col>
                                    <ion-col size="12" size-md="4" v-if="selectedFilter === 'YRL'">
                                        <ion-label>FY-Year</ion-label>
                                        <div class="border-line-34 margin-top-10">
                                            <ion-select
                                                class="form-select select-mobile"
                                                v-model="selectedYearly"
                                                @ionChange="changeYear($event)"
                                                placeholder=""
                                                interface="action-sheet"
                                            >
                                            <ion-select-option
                                                v-for="(monthlyRpt, index) in yearlyReport" 
                                                :key="index" 
                                                :value="monthlyRpt.id"
                                            >{{ monthlyRpt.name }}</ion-select-option>
                                            </ion-select>

                                            <select
                                                v-model="selectedYearly"
                                                class="input-select select-web"
                                                placeholder=""
                                                @change="changeYear($event)"
                                            >
                                            <option
                                                v-for="(monthlyRpt, index) in yearlyReport" 
                                                :key="index" 
                                                :value="monthlyRpt.id"
                                            >{{ monthlyRpt.name }}</option>
                                            </select>
                                        </div>
                                    </ion-col>
                                    <ion-col size="12" size-md="4" v-if="selectedFilter === 'YRL'">
                                        <ion-label>FY-Month</ion-label>
                                        <div class="border-line-34 margin-top-10">
                                            <ion-select
                                                class="form-select select-mobile"
                                                v-model="selectedMonth"
                                                @ionChange="changeMonth($event)"
                                                placeholder=""
                                                interface="action-sheet"
                                            >
                                            <ion-select-option
                                                v-for="(monthlyRpt, index) in monthlyReport" 
                                                :key="index" 
                                                :value="monthlyRpt.monthNo"
                                            >{{ monthlyRpt.displayName }}</ion-select-option>
                                            </ion-select>

                                            <select
                                                v-model="selectedMonth"
                                                class="input-select select-web"
                                                placeholder=""
                                                @change="changeMonth($event)"
                                            >
                                            <option
                                                v-for="(monthlyRpt, index) in monthlyReport" 
                                                :key="index" 
                                                :value="monthlyRpt.monthNo"
                                            >{{ monthlyRpt.displayName }}</option>
                                            </select>
                                        </div>
                                    </ion-col>
                                </ion-row>
                            </ion-col>
                            <ion-col size="12" size-md="3">
                                <br />
                                <ion-button class="btn-search margin-top-10" @click="getSelectedDashboardData">Search</ion-button>
                                <ion-button class="btn-clear margin-top-10" @click="clearFields">
                                    <ion-icon :icon="refresh"></ion-icon>
                                </ion-button>
                            </ion-col>
                        </ion-row>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
        
        <!-- <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div> -->
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-loading :is-open="isLoading" class="custom-loading" spinner="lines-sharp" message="Please Wait..." v-if="isLoading"></ion-loading>
                </ion-col>
            </ion-row>
        </ion-grid>

        <div v-if="loadChargerStausChart">
            <ChargerStatusDasboard :chartData="chargerStatusData"/>
        </div>
        <div v-if="loadConsumedEnergeyChart">
            <EnergyConsumedDashboard :consumeEnergyData="greenHousGasData"/>
        </div>
        <div v-if="!noStationAssociatedInd && !displayInd">
            <ion-grid>
                <ion-row class="rectangle">
                    <ion-col>
                        <p class="noAssociatedStations"  style="text-align: center;">No Associated Stations</p>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
        <div v-if="noDataForEnergy">
            <ion-grid>
                <ion-row class="rectangle">
                    <ion-col>
                        <p class="noStations1"  style="text-align: center;" >No data for input criteria</p>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { alertCircle, filter, refresh } from 'ionicons/icons';
// import Chart from "chart.js/auto";
import { CorporateService } from "../../service/corporate/corporate.service";
// import { flash } from 'ionicons/icons';
import { IonButton, IonRow, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonSelect, IonSelectOption, IonSpinner, IonLoading } from "@ionic/vue";
import { ToastUtils } from "../../util/toast-utils";
import { migratedTryParseServiceError } from "../../service";
import  ChargerStatusDasboard from "./ChargerStatusDashboard.vue";
import EnergyConsumedDashboard from "./EnergyConsumedDashboard.vue"

export default defineComponent ({
    name: 'adminDashboard',
    components: {
        IonGrid, IonRow, IonCol, IonLabel, IonSelect, 
        IonSelectOption, IonInput, IonButton, IonIcon, IonSpinner,
        ChargerStatusDasboard, EnergyConsumedDashboard, IonLoading
    },
    data() {
        return {
            isLoading: false,
            refresh,
            // chartTypes: [{'name' : 'Charger Status'},{"name" : "Admin Dashboard"}],
            chartTypes: [],
            chartName: "",
            // branchId: "",
            chartTypeInd: true,
            doughnutChartInd: true,
            myChart: null,
            chargerStatusData: "",
            displayInd: false,
            loaderTab: false,
            noStationAssociatedInd: true,
            displayLineChart1: false,
            displayLineChart2: false,
            displayLineChart3: false,
            displayLineChart4: false,
            displayChargerStatus: false,
            displayFenfeoAdminChart: false,
            chargerCurrentStatusChart: null,
            dailyUsageBarChart: null,
            greenHousGasData: null,
            customerVisitCountData: null,
            transactionCountData: null,
            revenueCountData: null,
            loadChargerStausChart: false,
            loadConsumedEnergeyChart: false,
            noDataForEnergy: false,
            displaySelectDashboard: true,
            branchList: [],
            stationList: [
                { stationId: 0, stationName: "All Stations" }
            ],
            outputList: [
                { outputId: 0, outputName: "All Outputs" }
            ],
            reportFilter: [],
            yearlyReport: [
                { id: 0, name: "All Years" },
            ],
            monthlyReport: [
                { monthNo: "0", displayName: "All Months" }
            ],
            selectedBranchId: "0",
            selectedStationId: "0",
            selectedOutputId: "0",
            selectedOutput: "0",
            selectedFilter: "LTD",
            selectedYearly: "0",
            selectedMonth: "0"
        }
    },
    async mounted() {
        try {
            const corporateService = new CorporateService();
            // 1. Load dashboard list
            this.chartTypes = await corporateService.getDashboardList();

            // 2. RESTORE saved selection
            const savedSelection = this.restoreDashboardSelection();

            // 3. Restore dashboard
            if (savedSelection &&
                savedSelection.chartName &&
                this.chartTypes.some(
                    chart =>
                        chart.dashboardCode === savedSelection.chartName
                )
            ) {
                this.chartName = savedSelection.chartName;
            } else if (this.chartTypes.length) {
                this.chartName = this.chartTypes[0].dashboardCode;
            }

            // 4. Load branches
            this.branchList = await corporateService.getBranchId();

            // 5. Restore branch
            if (savedSelection?.selectedBranchId) {

                const branchExists =
                    this.branchList.some(
                        branch =>
                            String(branch.branchId) === String(savedSelection.selectedBranchId)
                    );

                if (branchExists) {
                    this.selectedBranchId =savedSelection.selectedBranchId;
                }
            }

            // If no saved branch, keep your existing default behavior
            if (
                (!this.selectedBranchId ||
                this.selectedBranchId === "0") &&
                this.branchList.length === 1
            ) {
                this.selectedBranchId = this.branchList[0].branchId;
            }

            // 6. Load stations
            this.stationList = [
                { stationId: 0, stationName: "All Stations" }
            ];

            if (this.selectedBranchId && this.selectedBranchId !== "0") {

                const stations = await corporateService.getStationList(this.selectedBranchId);

                if (stations?.length) {
                    this.stationList = stations;
                }

                // 7. Restore station
                if (savedSelection?.selectedStationId) {

                    const stationExists =
                        this.stationList.some(
                            station =>
                                String(station.stationId) ===
                                String(savedSelection.selectedStationId)
                        );

                    if (stationExists) {
                        this.selectedStationId = savedSelection.selectedStationId;
                    }
                }

                // If no saved station and only one station
                if (
                    (!this.selectedStationId ||
                    this.selectedStationId === "0") &&
                    this.stationList.length === 1
                ) {
                    this.selectedStationId = this.stationList[0].stationId;
                }
            }

            // 8. Load outputs
            this.outputList = [
                { outputId: 0, outputName: "All Outputs" }
            ];

            if (
                this.selectedBranchId &&
                this.selectedBranchId !== "0" &&
                this.selectedStationId &&
                this.selectedStationId !== "0"
            ) {

                const outputs = await corporateService.getOutputList(
                        this.selectedBranchId,
                        this.selectedStationId
                    );

                if (outputs?.length) {
                    this.outputList = outputs;
                }

                // 9. Restore output
                if (savedSelection?.selectedOutputId) {

                    const outputExists =
                        this.outputList.some(
                            output =>
                                String(output.outputId) ===
                                String(savedSelection.selectedOutputId)
                        );

                    if (outputExists) {
                        this.selectedOutputId =
                            savedSelection.selectedOutputId;
                    }
                }

                // If no saved output and only one output
                if (
                    (!this.selectedOutputId ||
                    this.selectedOutputId === "0") &&
                    this.outputList.length === 1
                ) {
                    this.selectedOutputId = this.outputList[0].outputId;
                }
            }

            // 10. Load filters
            this.reportFilter = await corporateService.getFilterType();

            // 11. Restore filter
            if (
                savedSelection?.selectedFilter &&
                this.reportFilter.some(
                    filter =>
                        filter.code === savedSelection.selectedFilter
                )
            ) {
                this.selectedFilter =
                    savedSelection.selectedFilter;
            } else {
                this.selectedFilter = "LTD";
            }

            // 12. IMPORTANT:
            // If saved filter is YRL, load years BEFORE
            if (this.selectedFilter === "YRL") {

                this.yearlyReport =
                    await corporateService.getFinancialYears();

                if (
                    savedSelection?.selectedYearly &&
                    this.yearlyReport.some(
                        year =>
                            String(year.id) ===
                            String(savedSelection.selectedYearly)
                    )
                ) {
                    this.selectedYearly =
                        savedSelection.selectedYearly;
                }

                // 13. Load months for saved year
                if (
                    this.selectedYearly &&
                    this.selectedYearly !== "0"
                ) {

                    this.monthlyReport =
                        await corporateService.getFinancialMonths({
                            fyYear: this.selectedYearly
                        });

                    if (
                        savedSelection?.selectedMonth &&
                        this.monthlyReport.some(
                            month =>
                                String(month.monthNo) ===
                                String(savedSelection.selectedMonth)
                        )
                    ) {
                        this.selectedMonth =
                            savedSelection.selectedMonth;
                    }
                }
            } else {
                this.selectedYearly = "0";
                this.selectedMonth = "0";
            }


            // 14. Load dashboard using restored values
            if (this.chartName === "CS") {

                this.displayChargerStatus = true;
                this.displayFenfeoAdminChart = false;
                this.loadConsumedEnergeyChart = false;
                this.noDataForEnergy = false;

                await this.latestLoadGraphData();

            } else if (
                this.chartName === "CU" ||
                this.chartName === "CAD"
            ) {

                this.displayChargerStatus = false;
                this.loadChargerStausChart = false;

                await this.getGreenHouseGasUsageData();
            }

        } catch (error) {
            this.isLoading = false;
            const serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        }
    },
    // async mounted() {
    //     try {
    //         this.chartTypes = await new CorporateService().getDashboardList();
    //         if(this.chartTypes.length) {
    //             this.chartName = this.chartTypes[0].dashboardCode
    //         }
    //         this.branchList = await new CorporateService().getBranchId();
            
    //         if(this.branchList.length == 1) {
    //             this.selectedBranchId = this.branchList?.[0].branchId;
    //             this.stationList = await new CorporateService().getStationList(this.selectedBranchId);
    //             this.selectedStationId = this.stationList?.[0].stationId;
    //             if(this.stationList.length == 1) {
    //                 this.outputList = await new CorporateService().getOutputList(this.selectedBranchId, this.selectedStationId);
    //                 this.selectedOutputId = this.outputList?.[0].outputId;
    //             }
    //         }
    //         this.reportFilter = await new CorporateService().getFilterType();
    //         // console.log("386" , this.branchList);
    //         // console.log("386", this.reportFilter);
    //         // this.stationList = await new CorporateService().getStationList();
    //         // this.chartName = this.chartTypes[0].dashboardCode;
    //         // alert(this.chartName)
    //         // let branchId = localStorage.getItem('branchId');
    //         // if(branchId) {
    //         //     this.branchId = branchId;
    //         // }
    //         // localStorage.removeItem('branchSearch');
    //         // this.chartName = localStorage.getItem('dashboardType');
    //         // this.chartName = dashboartType;
    //         // this.displayChargerStatus = true;
    //         if (this.chartName === "CS") {
    //             // displayChargerStatus, displayFenfeoAdminChart no use
    //             this.displayChargerStatus = true;
    //             this.displayFenfeoAdminChart = false;
    //             this.loadConsumedEnergeyChart = false;
    //             this.noDataForEnergy = false;

    //             await this.latestLoadGraphData();     

    //         } else if (this.chartName === "CU" || this.chartName == 'CAD') {
    //             this.displayChargerStatus = false;
    //             this.loadChargerStausChart = false;

    //             const payload = {
    //                 branchId: this.selectedBranchId,
    //                 stationId: this.selectedStationId,
    //                 outputId: this.selectedOutputId,
    //                 filterId: this.selectedFilter
    //             };

    //             if (this.selectedFilter === 'YRL') {
    //                 payload.fyYear = this.selectedYearly;
    //                 payload.fyMonth = this.selectedMonth;
    //             }
    //             this.greenHousGasData = await new CorporateService().getGreenHousGasUsageForDashboard(payload);
                
    //             if (this.greenHousGasData.displayChart) {
    //                 this.displayFenfeoAdminChart = true;
    //                 this.displayInd = true;
    //                 this.loadConsumedEnergeyChart = true;
    //                 this.noDataForEnergy = false;
    //             } else {
    //                 this.noDataForEnergy = true;
    //             }
    //         }

           
    //     } catch(error) {
    //         this.isLoading = false;
    //         let serviceError = migratedTryParseServiceError(error);
    //         new ToastUtils().presentToast(serviceError.description)
    //     }
    //     //  this.latestLoadGraphData();    
            
         
    //     // try {
    //     //     let dashboartType = localStorage.getItem('dashboardType');
    //     //     if(dashboartType != null) {
    //     //         if(dashboartType == 'CS') {
    //     //             this.chartName = dashboartType;
    //     //             // this.displayChargerStatus = true;
    //     //             localStorage.removeItem('dashboardType');
    //     //             this.loadGraphData();
    //     //         } else if(dashboartType == 'AD') {
    //     //             this.chartName = dashboartType;
    //     //             localStorage.removeItem('dashboardType');
    //     //             this.chargerCurrentStatusChart = null;
    //     //             this.displayChargerStatus = false;
    //     //             let branchInfo = JSON.parse(localStorage.getItem('branchInfoForDashboard'));
    //     //             if(branchInfo) {
    //     //                 this.branchId = branchInfo.branchId;
    //     //                 this.greenHousGasData = await new CorporateService().getGreenHousGasUsageForDashboard(this.branchId);
    //     //                 if(this.greenHousGasData.displayChart == true) {
    //     //                     this.displayFenfeoAdminChart = true;
    //     //                     this.displayInd = true;
    //     //                     this.loadConsumedEnergeyChart =true;  
    //     //                 } else {
    //     //                     this.noDataForEnergy = true;
    //     //                 }
    //         //         } else {
    //         //             this.greenHousGasData = await new CorporateService().getGreenHousGasUsageForDashboard(this.branchId);
    //         //             if(this.greenHousGasData.displayChart == true) {
    //         //                 this.displayFenfeoAdminChart = true;
    //         //                 this.displayInd = true;
    //         //                 this.loadConsumedEnergeyChart =true;
    //         //             } else {
    //         //                 this.noDataForEnergy = true;
    //         //             }
    //         //         }
    //         //         this.displaySelectDashboard = false;
    //         //     }
    //         // } else {
    //         //     this.chartName = this.chartTypes[0].dashboardCode;
    //         //     if(this.chartName == 'CS') {
    //         //         this.loadConsumedEnergeyChart =false;
    //         //         this.noDataForEnergy= false;
    //         //         this.displaySelectDashboard = true;
    //         //         this.loadGraphData();
    //         //     } else if(this.chartName == 'AD') {
    //         //         this.loadChargerStausChart = false;
    //         //         this.noStationAssociatedInd = true;
    //         //         this.displaySelectDashboard = true;
    //         //         this.greenHousGasData = await new CorporateService().getGreenHousGasUsageForDashboard(this.branchId);
    //         //         if(this.greenHousGasData.displayChart == true) {
    //         //             this.displayFenfeoAdminChart = true;
    //         //             this.displayInd = true;
    //         //             this.loadConsumedEnergeyChart =true;
    //         //         } else {
    //         //             this.noDataForEnergy = true;
    //         //         }
    //     //             this.displaySelectDashboard = false;
    //     //         }
    //     //     }
    //     //     // if(dashboartType == 'Charger Status') {
    //     //     //     this.chartName = this.chartTypes[0].name;
    //     //     //     // this.displayChargerStatus = true;
    //     //     //     localStorage.removeItem('dashboardType');
    //     //     //     this.loadGraphData();
    //     //     // } else if(dashboartType == 'Admin Dashboard') {
    //     //     //     this.chartName = this.chartTypes[1].name;
    //     //     //     localStorage.removeItem('dashboardType');
    //     //     //     this.chargerCurrentStatusChart = null;
    //     //     //     this.displayChargerStatus = false;
    //     //     //     let branchInfo = JSON.parse(localStorage.getItem('branchInfoForDashboard'));
    //     //     //     if(branchInfo) {
    //     //     //         this.branchId = branchInfo.branchId;
    //     //     //         this.greenHousGasData = await new CorporateService().getGreenHousGasUsageForDashboard(this.branchId);
    //     //     //         if(this.greenHousGasData.displayChart == true) {
    //     //     //             this.displayFenfeoAdminChart = true;
    //     //     //             this.displayInd = true;
    //     //     //             this.loadConsumedEnergeyChart =true;  
    //     //     //         } else {
    //     //     //             this.noDataForEnergy = true;
    //     //     //         }
    //     //     //     } else {
    //     //     //         this.greenHousGasData = await new CorporateService().getGreenHousGasUsageForDashboard(this.branchId);
    //     //     //         if(this.greenHousGasData.displayChart == true) {
    //     //     //             this.displayFenfeoAdminChart = true;
    //     //     //             this.displayInd = true;
    //     //     //             this.loadConsumedEnergeyChart =true;
    //     //     //         } else {
    //     //     //             this.noDataForEnergy = true;
    //     //     //         }
    //     //     //     }
    //     //     //     this.displaySelectDashboard = false;
    //     //     // } else {
    //     //     //     this.chartName = this.chartTypes[0].name;
    //     //     //     this.displayChargerStatus = true
    //     //     //     this.loadGraphData();
    //     //     // }
    //     // } catch (error) {
    //     //     this.isLoading = false;
    //     //     let serviceError = migratedTryParseServiceError(error);
    //     //     new ToastUtils().presentToast(serviceError.description);
    //     // }
        
    // },
    methods: {
        saveDashboardSelection() {

            const dashboardSelection = {
                chartName: this.chartName,
                selectedBranchId: this.selectedBranchId,
                selectedStationId: this.selectedStationId,
                selectedOutputId: this.selectedOutputId,
                selectedFilter: this.selectedFilter,
                selectedYearly: this.selectedYearly,
                selectedMonth: this.selectedMonth
            };

            localStorage.setItem('adminDashboardSelection',JSON.stringify(dashboardSelection));
            return dashboardSelection;
        },
        restoreDashboardSelection() {
            const saved = localStorage.getItem('adminDashboardSelection');

            if (!saved) {
                return null;
            }

            try {
                return JSON.parse(saved);
            } catch (error) {
                console.log("Error parsing dashboard selection", error);
                return null;
            }
        },
        async changeBranch(event) {
            this.selectedBranchId = event.target.value;
            this.selectedStationId = "0";
            this.selectedOutputId = "0";
            this.stationList = [ { stationId: 0, stationName: "All Stations" }];
            this.outputList = [{ outputId: 0, outputName: "All Outputs" }];
            this.loadChargerStausChart = false;
            this.loadConsumedEnergeyChart = false;
            this.noDataForEnergy = false;
            if(this.selectedBranchId != 0) {
                this.stationList = await new CorporateService().getStationList(this.selectedBranchId);
                this.selectedStationId = this.stationList?.[0].stationId
                if(this.stationList.length == 1) {
                    this.outputList = await new CorporateService().getOutputList(this.selectedBranchId, this.selectedStationId);
                    this.selectedOutputId = this.outputList?.[0].outputId
                }
            }
           this.saveDashboardSelection();
        }, 
        async changeStation(event) {
            this.selectedStationId = event.target.value;
            this.loadChargerStausChart = false;
            this.loadConsumedEnergeyChart = false;
            this.noDataForEnergy = false;
            this.outputList = await new CorporateService().getOutputList(this.selectedBranchId, this.selectedStationId);
            this.selectedOutputId = this.outputList[0].outputId;
            // if (this.outputList && this.outputList.length > 0) {
            //     this.selectedOutputId = this.outputList[0].outputId;
            // } else {
            //     this.selectedOutputId = "0";
            // }
            // await this.latestLoadGraphData();
            // console.log("default output", this.selectedOutput);
            this.saveDashboardSelection();
        },
        changeOutput(event) {
            const outputId = event.target.value;

            this.selectedOutputId = outputId;

            this.selectedOutput = this.outputList.find(
                x => x.outputId == outputId
            );
            this.loadChargerStausChart = false;
            this.loadConsumedEnergeyChart = false;
            this.noDataForEnergy = false;
            // console.log("selectedOutput", this.selectedOutput);
            this.saveDashboardSelection();
        },
        async changeFilter(event) {
            this.selectedFilter = event.target.value;
            this.loadConsumedEnergeyChart = false;
            this.noDataForEnergy = false;
            this.selectedYearly = "0";
            this.selectedMonth = "0";
            if(this.selectedFilter === 'YRL') {
                this.yearlyReport = await new CorporateService().getFinancialYears();
            }
            this.saveDashboardSelection();
        }, 
        async changeYear(event) {
            this.selectedYearly = event.target.value;
            this.loadConsumedEnergeyChart = false;
            this.noDataForEnergy = false;
            this.selectedMonth = "0";
            this.monthlyReport = await new CorporateService().getFinancialMonths({fyYear: this.selectedYearly});
            this.saveDashboardSelection();
        }, 
        changeMonth(event) {
            this.selectedMonth = event.target.value;
            this.loadConsumedEnergeyChart = false;
            this.noDataForEnergy = false;
            this.saveDashboardSelection();
        },

        async latestLoadGraphData() {
            this.isLoading = true;
            this.loadChargerStausChart = false
            // alert(this.selectedOutputId)
            this.chargerStatusData = await new CorporateService().getChargerStatusDataForDashboard({
                branchId: this.selectedBranchId,
                stationId: this.selectedStationId,
                outputId: this.selectedOutputId
                // no need below details
                // outputDetails: this.selectedOutputId != 0 ? this.selectedOutput : null
            });
            if(this.chargerStatusData.displayData.totalCount > 0) {
                this.displayChargerStatus = true;
                this.displayInd = true;
                // this.loaderTab = false;
                this.isLoading = false;
                this.loadChargerStausChart = true;
            
            } else {
                this.isLoading = false;
                this.displayInd = false;
                this.displayChargerStatus = true;
                this.noStationAssociatedInd = false;
            }
        },
        async loadGraphData() {
            // this.loaderTab = true;
            this.isLoading = true;
            try {
                // let branchId = localStorage.getItem('branchId');
                // if(branchId == '') {
                //     this.branchId = branchId;
                    
                //     this.chargerStatusData = await new CorporateService().getChargerStatusDataForDashboard(this.branchId);
                //     if(this.chargerStatusData.displayData.totalCount > 0) {
                //         this.displayChargerStatus = true;
                //         this.displayInd = true;
                //         this.loaderTab = false;
                //         this.loadChargerStausChart = true;
                //     } else {
                //         this.noStationAssociatedInd = false;
                //     }
                // } else {
                    let branchInfo = JSON.parse(localStorage.getItem('branchInfoForDashboard'));
                    let branchIDFromDashboard = localStorage.getItem('branchIDFromDashboard');
                    if(branchInfo) {
                        this.branchId = branchInfo.branchId;
                        this.chargerStatusData = await new CorporateService().getChargerStatusDataForDashboard({
                            branchId: this.selectedBranchId,
                            stationId: this.selectedStationId,
                            outputId: this.selectedOutputId
                        });
                        if(this.chargerStatusData.displayData.totalCount > 0) {
                            this.loadChargerStausChart = true;
                            this.displayChargerStatus = true;
                            this.displayInd = true;
                            // localStorage.removeItem('branchInfoForDashboard');
                            // this.loaderTab = false;
                            this.isLoading = false;
                            
                        } else {
                            this.displayInd = false;
                            this.noStationAssociatedInd = false;
                        }
                    } else if(branchIDFromDashboard) {
                        this.branchId = branchIDFromDashboard
                        this.chargerStatusData = await new CorporateService().getChargerStatusDataForDashboard({
                            branchId: this.selectedBranchId,
                            stationId: this.selectedStationId,
                            outputId: this.selectedOutput
                        });
                        if(this.chargerStatusData.displayData.totalCount > 0) {
                            this.displayChargerStatus = true;
                            this.displayInd = true;
                            // this.loaderTab = false;
                            this.isLoading = false;
                            this.loadChargerStausChart = true;
                            localStorage.removeItem('branchIDFromDashboard');
                        } else {
                            this.noStationAssociatedInd = false;
                        }
                    } else {
                        this.chargerStatusData = await new CorporateService().getChargerStatusDataForDashboard({
                            branchId: this.selectedBranchId,
                            stationId: this.selectedStationId,
                            outputId: this.selectedOutputId,
                            outputDetails: this.selectedOutputId != 0 ? this.selectedOutput : null
                        });
                        if(this.chargerStatusData.displayData.totalCount > 0) {
                            this.displayChargerStatus = true;
                            this.displayInd = true;
                            // this.loaderTab = false;
                            this.isLoading = false;
                            this.loadChargerStausChart = true;
                        
                        } else {
                            this.displayInd = false;
                            this.displayChargerStatus = true;
                            this.noStationAssociatedInd = false;
                        }
                    }
                
                // }
                this.displaySelectDashboard = false;
            } catch (error) {
                this.isLoading = false;
                this.displaySelectDashboard = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
            
        },

        async selectDashboardChart(event) {

            this.chartName = event.target.value;

            this.loadChargerStausChart = false;
            this.loadConsumedEnergeyChart = false;
            this.noDataForEnergy = false;

            this.displayInd = false;

            if (this.chartName === "CS") {

                this.displayChargerStatus = true;
                this.displayFenfeoAdminChart = false;
                await this.latestLoadGraphData();
            } else if (
                this.chartName === "CU" ||
                this.chartName === "CAD"
            ) {

                this.displayChargerStatus = false;
                await this.getGreenHouseGasUsageData();
            }

            this.saveDashboardSelection();
        },

        async clearFields() {
            localStorage.removeItem('adminDashboardSelection');
            this.isLoading = true;
            this.loadChargerStausChart = false;
            this.loadConsumedEnergeyChart = false;
            this.noStationAssociatedInd = true;
            this.noDataForEnergy = false;
            this.selectedBranchId = "0";
            this.selectedStationId = "0";
            this.selectedOutputId = "0";
            // this.selectedFilter = "LTD";
            this.selectedYearly = "0";
            this.selectedMonth = "0";
            this.stationList = [{ stationId: 0, stationName: "All Stations" }];
            this.outputList = [{ outputId: 0, outputName: "All Ports" }];
            // this.yearlyReport = [{ id: 0, name: "All Years" },];
            this.monthlyReport = [{ monthNo: "0", displayName: "All Months" }];
            try {
                if(this.chartName == 'CS' ) {
                    // this.branchId = null;
                    // this.displayInd = false;
                    // document.getElementById("branchId").value = null;
                    // this.branchId = '';
                    // localStorage.removeItem('branchInfoForDashboard');
                    // localStorage.removeItem('branchSearch');
                    // localStorage.removeItem('branchId');
                    this.chargerStatusData = await new CorporateService().getChargerStatusDataForDashboard({
                        branchId: this.selectedBranchId,
                        stationId: this.selectedStationId,
                        outputId: this.selectedOutputId,
                        outputDetails: this.selectedOutputId != 0 ? this.selectedOutput : null
                    });
                    if(this.chargerStatusData.displayData.totalCount > 0) {
                        this.displayChargerStatus = true;
                        this.displayInd = true;
                        this.loadChargerStausChart = true;
                    } else {
                        this.noStationAssociatedInd = false;
                    }
                } else if(this.chartName == 'CU'  || this.chartName == 'CAD') {
                    // localStorage.removeItem('branchInfoForDashboard');
                    // this.branchId = null;
                    // document.getElementById("branchId").value = null;
                    // this.branchId = '';
                    let yearlyFilterCode;

                    this.reportFilter.forEach(filter => {
                        if (filter.code === 'YRL') {
                            yearlyFilterCode = filter.code;
                        }
                    });

                    
                    const payload = {
                        branchId: this.selectedBranchId,
                        stationId: this.selectedStationId,
                        outputId: this.selectedOutputId,
                        filterId: this.selectedFilter
                    };

                    if (this.selectedFilter === yearlyFilterCode) {
                        payload.fyYear = this.selectedYearly;
                        payload.fyMonth = this.selectedMonth;
                    }

                    this.greenHousGasData = await new CorporateService().getGreenHousGasUsageForDashboard(payload);
                    if(this.greenHousGasData.displayChart == true) {
                        this.greenHousGasData["branchDetails"] = payload;
                        this.displayFenfeoAdminChart = true;
                        this.displayInd = true;
                        this.loadConsumedEnergeyChart =true;
                        this.noDataForEnergy = false;
                    } else {
                        this.noDataForEnergy = true;
                    }
                    this.displaySelectDashboard = false;
                }
                this.isLoading = false;
            } catch(error) {
                // new ToastUtils().presentToast(error.response.data.errors[0].detail);
                this.isLoading = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        
        },
        // async getGreenHouseGasUsageData() {
        //     this.isLoading = true;
        //     let yearlyFilterCode;

        //     this.reportFilter.forEach(filter => {
        //         if (filter.code === 'YRL') {
        //             yearlyFilterCode = filter.code;
        //         }
        //     });

            
        //     const payload = {
        //         branchId: this.selectedBranchId,
        //         stationId: this.selectedStationId,
        //         outputId: this.selectedOutputId,
        //         filterId: this.selectedFilter
        //     };

        //     if (this.selectedFilter === yearlyFilterCode) {
        //         payload.fyYear = this.selectedYearly;
        //         payload.fyMonth = this.selectedMonth;
        //     }

        //     console.log("825" + JSON.stringify(payload))
        //     this.greenHousGasData = await new CorporateService().getGreenHousGasUsageForDashboard(payload);
        //     console.log("821 this.greenHousGasData " + JSON.stringify(this.greenHousGasData))
        //     // console.log("1 consumeEnergyData ", JSON.stringify(this.greenHousGasData));
        //     // this.loaderTab = false;
        //     this.isLoading = false;
           
        //     // console.log("2 consumeEnergyData ", JSON.stringify(this.greenHousGasData));
        //     if(this.greenHousGasData.displayChart == true) {
        //         // alert("test")
        //          this.greenHousGasData["branchDetails"] = payload;
        //         this.displayFenfeoAdminChart = true;
        //         this.displayInd = true;
        //         this.loadConsumedEnergeyChart =true;
        //         this.noDataForEnergy = false;
        //     } else {
        //         this.loadConsumedEnergeyChart =false;
        //         this.noDataForEnergy = true;
        //     }
        //     this.displaySelectDashboard = false;
        // },
        
        async getGreenHouseGasUsageData() {

            const requestId = Date.now();

            this.isLoading = true;

            let yearlyFilterCode;

            this.reportFilter.forEach(filter => {
                if (filter.code === 'YRL') {
                    yearlyFilterCode = filter.code;
                }
            });

            const payload = {
                branchId: this.selectedBranchId,
                stationId: this.selectedStationId,
                outputId: this.selectedOutputId,
                filterId: this.selectedFilter
            };

            if (this.selectedFilter === yearlyFilterCode) {
                payload.fyYear = this.selectedYearly;
                payload.fyMonth = this.selectedMonth;
            }

            const response = await new CorporateService().getGreenHousGasUsageForDashboard(payload);


            this.greenHousGasData = response;

            this.isLoading = false;

            if (this.greenHousGasData.displayChart === true) {

                this.greenHousGasData = {
                    ...this.greenHousGasData,
                    branchDetails: payload
                };

                this.displayFenfeoAdminChart = true;
                this.displayInd = true;
                this.loadConsumedEnergeyChart = true;
                this.noDataForEnergy = false;

            } else {

                this.loadConsumedEnergeyChart = false;
                this.noDataForEnergy = true;
            }

            this.displaySelectDashboard = false;
        },

        
        async searchBranches() {
            await this.latestLoadGraphData();
            // localStorage.setItem('fromAdminDashboard', 'Y');
            // localStorage.setItem('dashboardType', this.chartName);
            // localStorage.setItem('branchId', this.branchId);
            // this.$router.push({name: "branchCPO", params: { branchId: this.branchId }});
        },
        async getSelectedDashboardData() {
            this.saveDashboardSelection();
            if(this.chartName == 'CS') {
               await this.latestLoadGraphData();
                    
            } else if(this.chartName == 'CU' || this.chartName == 'CAD') {
                await this.getGreenHouseGasUsageData();
                
            }
        }
    },
})
</script>

<style scoped>
.container-div {
  margin: 0px 20px 0px 20px ;
}

/* Search Section */

.search-view {
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, .08);
}

.border-line-34 {
  width: 100%;
}

.form-select,
.input-select,
.form-input,
ion-select,
ion-input,
select {
  width: 100%;
}

.margin-top-10 {
  margin-top: 10px;
}

/* Status Colors */

.available {
  color: green;
}

.unavailable {
  color: red;
}

.charging {
  color: orange;
}

.thirdparty {
  color: #26285a;
}

.total {
  color: #9f15df;
}

/* Status Box */

.status-info {
  padding: 20px;
  margin-top: 20px;
  border: 2px solid #d9d9d9;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, .08);
}

.noStations,
.noStations1,
.noAssociatedStations {
  font-weight: bold;
  text-align: center;
  margin: 20px 0;
}

/* Charts */

.my-chart {
  width: 100% !important;
  max-width: 450px;
  height: 450px !important;
  margin: auto;
  display: block;
}

.barChart1 {
  height: 370px !important;
}

.chart-label {
  margin: 0;
  padding: 0;
  text-align: center;
}

.display-value {
  margin: 0;
  padding: 0;
  font-weight: bold;
}

/* Cards */

.rectangle,
.rectangle-dump,
.rectangle-dump1 {
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 15px;
}

/* Buttons */

.btn-search {
  width: 100px;
  height: 40px;
}

.btn-clear {
  width: 45px;
  height: 40px;
  margin-left: 6px;
}

.btn-refresh {
  margin-left: 10px;
  font-size: 1.2rem;
  height: 40px;

  --background: #e1899c;
  --background-focused: #b4b2b2;
  --background-hover: #b4b2b2;
}

/* Loading */

ion-loading.custom-loading {
  --background: #d0cbcb;
  --spinner-color: #0bc954;
  --height: 7%;
  color: #1a1b1c;
}

/* ===========================
   Laptop
=========================== */

@media (max-width: 1200px) {

  .container-div {
    margin: 15px;
  }

  .my-chart {
    max-width: 380px;
    height: 380px !important;
  }

}

/* ===========================
   Tablet
=========================== */

@media (max-width: 991px) {

  .container-div {
    margin: 10px;
  }

  .search-view {
    padding: 15px;
  }

  ion-col {
    margin-bottom: 15px;
  }

  .btn-search {
    width: 100%;
  }

  .btn-clear {
    width: 100%;
    margin-left: 0;
    margin-top: 10px;
  }

  .status-info {
    margin-top: 10px;
    padding: 15px;
  }

  .my-chart {
    max-width: 330px;
    height: 330px !important;
  }

}

/* ===========================
   Mobile
=========================== */

@media (max-width: 576px) {

  .container-div {
    margin: 8px;
  }

  .search-view {
    padding: 12px;
  }

  ion-label {
    font-size: 14px;
  }

  .form-select,
  .input-select,
  ion-select,
  ion-input,
  select {
    font-size: 14px;
  }

  .btn-search,
  .btn-clear {
    width: 100%;
    margin: 10px 0 0;
  }

  .status-info {
    padding: 12px;
    margin-right: 0;
  }

  .my-chart {
    max-width: 260px;
    height: 260px !important;
  }

}

/* ===========================
   Small Phones
=========================== */

@media (max-width: 360px) {

  .container-div {
    margin: 5px;
  }

  .search-view {
    padding: 10px;
  }

  ion-label {
    font-size: 13px;
  }

  .my-chart {
    max-width: 220px;
    height: 220px !important;
  }

}

</style>